import { type TreeNode } from '@direct-frontend/components';

// Create a map of nodes by ID for efficient lookups
export const createNodeMap = (nodes: TreeNode[]): Map<string, TreeNode> => {
    const nodeMap = new Map<string, TreeNode>();

    const populateNodeMap = (nodeList: TreeNode[]) => {
        for (const node of nodeList) {
            nodeMap.set(node.id, node);

            if (node.children && node.children.length > 0) {
                populateNodeMap(node.children);
            }
        }
    };

    populateNodeMap(nodes);

    return nodeMap;
};
